const state = {
    brands: [
        "Logo-smartfit-black.png",
        "Bioritmo_logo.png",
        "nos.png",
        "LOGO_RACE-01.png",
        "TONUSGYM-B.png",
        "JAB-HOUSE-B.png",
        "VIDYA-B.png",
        "qd-marca_preta.png"
    ],
    ourAreas: [
        { id: 2835, title: "Academias", icon:"ico-academias.svg" },
        { id: 2834, title: "Atendimento", icon:"ico-atendimento.svg" },
        { id: 2839, title: "Business Intelligence", icon:"ico-gestao.svg" },
        { id: 2831, title: "Comercial", icon:"ico-relacionamento.svg" },
        { id: 2830, title: "Engenharia", icon:"ico-gestao.svg" },
        { id: 2836, title: "Financeiro", icon:"ico-financeiro.svg" },
        { id: 2838, title: "Jurídico", icon:"ico-juridico.svg" },
        { id: 2841, title: "Marketing", icon:"ico-ativacao.svg" },
        { id: 2840, title: "Produto", icon:"ico-produto.svg" },
        { id: 2837, title: "Recursos Humanos", icon:"ico-ativacao.svg" },
        { id: 2832, title: "Relacionamento com Recursos Humanos", icon:"ico-gestao.svg" }
    ]
}

export {state}